import { useAgentPlatformConnections } from "@/pages/DeploymentsPage/application/useAgentPlatform"
import { CopilotStudioSettingsModal } from "@/pages/DeploymentsPage/components/organisms/CopilotStudioConnection"
import { useThreatDetection } from "../hooks/useThreatDetection"
import { ConnectionSettingsState } from "./ConnectionSettingsState"

import type { PlatformSettingsProps } from "../CloudConnectionSettings.types"

// A Microsoft tenant's settings, from its row
export const CopilotStudioSettings = (props: PlatformSettingsProps) => {
  const connections = useAgentPlatformConnections("copilot-studio")
  const threatDetection = useThreatDetection(
    connections.connections.find(
      ({ connectionId }) => connectionId === props.connectionId
    )
  )

  return (
    <ConnectionSettingsState {...connections} {...props}>
      {(connection) => (
        <CopilotStudioSettingsModal
          connection={connection}
          threatDetection={threatDetection}
          onClose={props.onClose}
        />
      )}
    </ConnectionSettingsState>
  )
}
